import { cn } from '@bem-react/classname';

export const cnDrawer = cn('Drawer');
export const cnDrawerOverlay = cnDrawer('Overlay');
export const cnDrawerContent = cnDrawer('Content');
export const cnDrawerTitle = cnDrawer('Title');
export const cnDrawerHandle = cnDrawer('Handle');
export const cnDrawerCurtain = cnDrawer('Curtain');
export const cnDrawerCurtainContent = cnDrawer('CurtainContent');
export const cnDrawerDragObserver = cnDrawer('DragObserver');
